export default function (language) {
  return {
    scheduler: {
      status: [
        {
          id: 0,
          title: language.scheduler.status.waiting,
          color: 'amber',
          icon: 'mdi-clock-outline',
          class: 'waiting'
        },
        {
          id: 1,
          title: language.scheduler.status.adjourned,
          color: 'orange darken-1',
          icon: 'mdi-update',
          class: 'adjourned'
        },
        {
          id: 2,
          title: language.scheduler.status.completed,
          color: 'green',
          icon: 'mdi-check-all',
          class: 'completed'
        },
        {
          id: 3,
          title: language.scheduler.status.canceled,
          color: 'gray',
          icon: 'mdi-close-circle',
          class: 'canceled'
        },
        {
          id: 4,
          title: language.scheduler.status.deleted,
          color: 'red',
          icon: 'mdi-trash-can-outline',
          class: 'deleted'
        }
      ],
      history: [
        {
          id: 1,
          title: language.scheduler.view.history.created,
          icon: 'mdi-plus',
          color: 'blue'
        },
        {
          id: 2,
          title: language.scheduler.view.history.edited,
          icon: 'mdi-account-edit',
          color: 'orange'
        },
        {
          id: 3,
          title: language.scheduler.view.history.deleted,
          icon: 'mdi-close-circle',
          color: 'red'
        }
      ]
    },
    catalog: {
      items: {
        stock: [
          { id: 0, title: language.items.stock.disabled },
          { id: 1, title: language.items.stock.enabled }
        ]
      }
    },
    orders: {
      types: [
        { id: 1, title: language.orders.type.delivery },
        { id: 2, title: language.orders.type.local }
      ],
      status: [
        {
          id: 1,
          title: language.orders.status.waiting,
          color: 'red',
          class: 'waiting',
          icon: 'mdi-alert-circle'
        },
        {
          id: 2,
          title: language.orders.status.scheduled,
          color: 'amber',
          class: 'scheduled',
          icon: 'mdi-calendar-check'
        },
        {
          id: 3,
          title: language.orders.status.execution,
          color: 'deep-orange',
          class: 'execution',
          icon: 'mdi-clock-outline'
        },
        {
          id: 4,
          title: language.orders.status.ready,
          color: 'deep-purple',
          class: 'ready',
          icon: 'mdi-check'
        },
        {
          id: 5,
          title: language.orders.status.delivery,
          color: 'orange',
          class: 'delivery',
          icon: 'mdi-truck-fast'
        },
        {
          id: 6,
          title: language.orders.status.delivered,
          color: 'blue',
          class: 'delivered',
          icon: 'mdi-truck-check'
        },
        {
          id: 7,
          title: language.orders.status.completed,
          color: 'green',
          class: 'completed',
          icon: 'mdi-check-all'
        },
        {
          id: 8,
          title: language.orders.status.canceled,
          color: 'grey',
          class: 'canceled',
          icon: 'mdi-close-circle'
        }
      ],
      payment: {
        type: [
          { header: language.orders.new.payment.paid.types.discount.title },
          { text: language.orders.new.payment.paid.types.discount.percent, value: 1 },
          { text: language.orders.new.payment.paid.types.discount.currency, value: 2 },
          { header: language.orders.new.payment.paid.types.payment.title },
          { text: language.orders.new.payment.paid.types.payment.debtcard, value: 3 },
          { text: language.orders.new.payment.paid.types.payment.creditcard, value: 4 },
          { text: language.orders.new.payment.paid.types.payment.money, value: 5 },
          { text: language.orders.new.payment.paid.types.payment.transfer, value: 6 }
        ],
        status: [
          {
            id: 0,
            title: language.orders.payment.pending,
            color: 'deep-orange',
            icon: 'mdi-cash-remove'
          },
          {
            id: 1,
            title: language.orders.payment.half,
            color: 'orange',
            icon: 'mdi-cash-lock'
          },
          {
            id: 2,
            title: language.orders.payment.paid,
            color: 'green',
            icon: 'mdi-cash-check'
          }
        ]
      },
      history: [
        {
          id: 1,
          title: language.orders.view.history.created,
          icon: 'mdi-alert-circle',
          color: 'red'
        },
        {
          id: 2,
          title: language.orders.view.history.edited,
          icon: 'mdi-playlist-edit',
          color: 'amber'
        },
        {
          id: 3,
          title: language.orders.view.history.scheduled,
          icon: 'mdi-clock-outline',
          color: 'yellow darken-2'
        },
        {
          id: 4,
          title: language.orders.view.history.delivery,
          icon: 'mdi-truck-fast',
          color: 'orange'
        },
        {
          id: 5,
          title: language.orders.view.history.delivered,
          icon: 'mdi-truck-check',
          color: 'blue'
        },
        {
          id: 6,
          title: language.orders.view.history.canceled,
          icon: 'mdi-close-circle',
          color: 'grey'
        },
        {
          id: 7,
          title: language.orders.view.history.completed,
          icon: 'mdi-check-all',
          color: 'green'
        },
        {
          id: 8,
          title: language.orders.view.history.deleted,
          icon: 'mdi-trash-can-outline',
          color: 'black'
        },
        {
          id: 9,
          title: language.orders.view.history.payment,
          icon: 'mdi-cash-multiple',
          color: 'light-green'
        }
      ],
      widget: {
        menu: {
          services: [
            {
              id: 1,
              title: language.orders.new.order.toolbar.actions.services.schedule,
              icon: 'mdi-calendar-clock',
              action: 3
            }
          ],
          items: [
            {
              id: 1,
              title: language.orders.new.order.toolbar.actions.items.deliver,
              icon: 'mdi-truck-delivery-outline',
              action: 3
            }
          ]
        }
      }
    },
    customers: {
      history: [
        {
          id: 1,
          title: language.customers.view.history.created,
          icon: 'mdi-plus',
          color: 'blue'
        },
        {
          id: 2,
          title: language.customers.view.history.edited,
          icon: 'mdi-account-edit',
          color: 'orange'
        },
        {
          id: 3,
          title: language.customers.view.history.order,
          icon: 'mdi-cash-multiple',
          color: 'green'
        }
      ]
    },
    historic: {
      filters: {
        order: {
          operation: [
            { id: 0, title: language.historic.filters.order.operation.categories },
            { id: 1, title: language.historic.filters.order.operation.or },
            { id: 2, title: language.historic.filters.order.operation.and }
          ]
        }
      }
    },
    financial: {
      cashflow: {
        types: [
          {
            id: 1,
            title: language.financial.cashflow.new.types.payment,
            icon: 'mdi-cash-multiple'
          },
          {
            id: 2,
            title: language.financial.cashflow.new.types.expense,
            icon: 'mdi-cash-minus'
          }
        ],
        categories: [
          {
            id: 1,
            title: language.financial.cashflow.new.categories.salary,
            icon: 'mdi-account-tie'
          },
          {
            id: 5,
            title: language.financial.cashflow.new.categories.comissions,
            icon: 'mdi-sack-percent'
          },
          {
            id: 2,
            title: language.financial.cashflow.new.categories.bills,
            icon: 'mdi-receipt'
          },
          {
            id: 3,
            title: language.financial.cashflow.new.categories.stock,
            icon: 'mdi-package-variant-closed'
          },
          {
            id: 4,
            title: language.financial.cashflow.new.categories.other,
            icon: 'mdi-cube-outline'
          }
        ],
        methods: [
          {
            id: 1,
            title: language.orders.new.payment.paid.types.payment.debtcard
          },
          {
            id: 2,
            title: language.orders.new.payment.paid.types.payment.creditcard
          },
          {
            id: 3,
            title: language.orders.new.payment.paid.types.payment.money
          },
          {
            id: 4,
            title: language.orders.new.payment.paid.types.payment.transfer
          }
        ]
      },
      periodicals: {
        periods: [
          {
            id: 1,
            title: language.financial.periodicals.new.periods.monthly
          },
          {
            id: 2,
            title: language.financial.periodicals.new.periods.quarterly
          },
          {
            id: 3,
            title: language.financial.periodicals.new.periods.semester
          },
          {
            id: 4,
            title: language.financial.periodicals.new.periods.annual
          },
          {
            id: 5,
            title: language.financial.periodicals.new.periods.biannual
          }
        ]
      },
      salary: {
        categories: [
          {
            id: 1,
            title: language.financial.cashflow.new.categories.salary,
            icon: 'mdi-account-tie'
          },
          {
            id: 5,
            title: language.financial.cashflow.new.categories.comissions,
            icon: 'mdi-sack-percent'
          }
        ]
      }
    },
    users: {
      status: [
        {
          id: 0,
          title: language.users.status.idle,
          color: 'amber',
          class: 'idle'
        },
        {
          id: 1,
          title: language.users.status.absent,
          color: 'red',
          class: 'absent'
        },
        {
          id: 2,
          title: language.users.status.active,
          color: 'green',
          class: 'active'
        }
      ],
      history: [
        {
          id: 1,
          title: language.users.view.history.created,
          icon: 'mdi-plus',
          color: 'blue'
        },
        {
          id: 2,
          title: language.users.view.history.edited,
          icon: 'mdi-account-edit',
          color: 'orange'
        }
      ]
    },
    permissions: {
      colors: [
        { title: language.permissions.new.colors.blue, value: 'blue' },
        { title: language.permissions.new.colors.indigo, value: 'indigo' },
        { title: language.permissions.new.colors.amber, value: 'amber' },
        { title: language.permissions.new.colors.orange, value: 'orange' },
        { title: language.permissions.new.colors.lightgreen, value: 'light-green' },
        { title: language.permissions.new.colors.deeppurple, value: 'deep-purple' },
        { title: language.permissions.new.colors.red, value: 'red' },
        { title: language.permissions.new.colors.pink, value: 'pink' },
        { title: language.permissions.new.colors.purple, value: 'purple' },
        { title: language.permissions.new.colors.cyan, value: 'cyan' },
        { title: language.permissions.new.colors.teal, value: 'teal' },
        { title: language.permissions.new.colors.green, value: 'green' }
      ]
    }
  }
}
